<template>
    <div class="add-news-headImg-box">
        <el-form ref="headImgForm" label-width="100px">
            <template v-for="(imageItem, index) in headImgForm">
                <el-card class="box-card">
                    <el-form-item label="图片链接"  prop="image">
                        <el-input v-model="headImgForm[index].image" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="落地链接"  prop="link">
                        <el-input v-model="headImgForm[index].link" auto-complete="off"></el-input>
                    </el-form-item>
                </el-card>
            </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="headImgForm.length > 1" @click="deleteHeadImgCard" size="small">删除卡片</el-button>
            <el-button @click="addHeadImgCard" type="primary" size="small">增加卡片</el-button>
            <el-button @click="clearAddNewsForm" size="small">取 消</el-button>
            <el-button type="primary" @click="createHeadImg" size="small">确 定</el-button>
        </div>
        <div class="preview-box">
            <HeadImgComponent :newsData="this.headImgForm" :isAd="false"></HeadImgComponent>
        </div>
    </div>
</template>
<script>
    import HeadImgComponent from '../newsTemplate/HeadImg.vue';
    import CONFIG from "@/config/index.js";
    import { mapGetters } from 'vuex';
    export default{
        props: ["specialId", "newsTypeId", "refreshNews"],
        data(){
            return {
                headImgForm: [{
                    image: null,
                    link: '#'
                }]
            };
        },
        components: {
            HeadImgComponent
        },
        computed: {
            ...mapGetters({
                userInfo: 'getUserInfo'
            })
        },
        methods: {
            createHeadImg(){
                let arrStr = {
                    image: '',
                    link: ''
                };
                for(let i = 0; i < this.headImgForm.length; i++){
                    if (i < this.headImgForm.length -1) {
                        arrStr.image += this.headImgForm[i].image + ';';
                        arrStr.link += (this.headImgForm[i].link || '#' ) + ';';
                    } else {
                        arrStr.image += this.headImgForm[i].image;
                        arrStr.link += this.headImgForm[i].link || '#';
                    }
                }
                this.$http.post(CONFIG.HOST + '/special/addNews', {
                    newsContentTitle: '图集',
                    newsContentCreateUser: this.userInfo.userId,
                    newsContentUpdateUser: this.userInfo.userId,
                    newsTypeId: this.newsTypeId,
                    specialId: this.specialId,
                    newsContentImage: arrStr.image,
                    newsContentURL: arrStr.link,
                    newsContentSource: '一点资讯',
                    newsContentIsTop: 0
                }).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】商业专题-头图创建成功'
                        });
                        this.clearAddNewsForm();
                        this.refreshNews();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response)=>{
                    console.log(response);
                });
            },
            addHeadImgCard(){
                this.headImgForm.push({
                    image: null,
                    link: '#'
                });
            },
            deleteHeadImgCard(){
                this.headImgForm.splice(this.headImgForm.length - 1, 1);
            },
            clearAddNewsForm(){
                this.headImgForm = [{
                    image: null,
                    link: '#'
                }];
            }
        }
    }
</script>
<style lang="less">
    .add-news-headImg-box{
        .preview-box{
            text-align: left;
            padding-left: 14px;
            margin: 10px auto;
        }
        .box-card{
            margin-left: 8px;
        }
    }
</style>




// WEBPACK FOOTER //
// HeadImg.vue?3c77295e